import { useState, useEffect } from 'react';
import { apiCall } from '../api/client';
import type { ChainLockStatusResponse } from '../api/types';

const DEFAULT_CHAINLOCKS_POLL_MS =
  Number(import.meta.env.VITE_CHAINLOCKS_POLL_INTERVAL_MS) || 15000;

export function useChainlocks(refreshInterval = DEFAULT_CHAINLOCKS_POLL_MS) {
  const [data, setData] = useState<ChainLockStatusResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [pollTick, setPollTick] = useState(0);

  const fetchChainlocks = async () => {
    setPollTick((prev) => prev + 1);
    try {
      const status = await apiCall<ChainLockStatusResponse>('/chainlocks/status');
      setData(status);
      setError(null);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChainlocks();

    if (refreshInterval > 0) {
      const interval = setInterval(fetchChainlocks, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  return {
    data,
    loading,
    error,
    refetch: fetchChainlocks,
    pollInterval: refreshInterval,
    pollTick,
  };
}
